import type { ImageVariant } from '-/Custom/Util.types';

export default function getCloudflareMediaUrl({
  id,
  variant,
}: {
  id: string | null;
  variant: ImageVariant | number;
}) {
  return `${process.env.EXPO_PUBLIC_CLOUDFLARE_IMAGE_URL}/${id}/${variant}`;
}
